import { useEffect } from 'react';
import { useGiftCards } from '~Hooks';
import { RefundProps } from '../types';

export const RefundBaemingoGiftcard = ({
  amount,
  onCompleted,
  onFail,
  transactionId,
}: RefundProps) => {
  const giftCards = useGiftCards();

  useEffect(() => {
    if (!transactionId) {
      return onFail('Missing transactionId');
    }

    giftCards
      .refundPayment(transactionId, amount)
      .then(({ data }) => {
        if (!data) {
          return onFail('No data returned');
        }

        const { success, message } = data.refundGiftcardPayment;
        if (!success) {
          return onFail(message);
        }

        onCompleted();
      })
      .catch((err) => {
        onFail(err);
      });
  }, []);

  return null;
};

export default RefundBaemingoGiftcard;
